<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog v-model="dialog.discount" 
      persistent
      width="750">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5">
          Detail Diskon Booking Unit
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="250">Judul</th>
                  <th class="text-left">Keterangan</th>
                  <th class="text-right">Diskon</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(item, index) in discount" 
                  :key="index">
                  <td class="text-second">
                    {{ item.title }}
                  </td>
                  <td class="caption text-second">
                    <span v-html="item.desc"></span>
                  </td>
                  <td class="caption text-second text-right">
                    {{ parseInt(item.price) | price }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
            color="red"
            class="text-capitalize"
            @click="dialog.discount = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="12">
        <v-card
          class="border-radius box-shadow">
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="3">
                <v-select
                  dense
                  outlined
                  :items="items.project"
                  item-text="project_name"
                  item-value="project_id"
                  item-color="light-greeb lighten-2"
                  v-model="filter.project_id"
                  label="Proyek"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  dense
                  outlined
                  :items="items.unit"
                  item-text="unit_type_name"
                  item-value="unit_type_id"
                  item-color="light-green lighten-2"
                  v-model="filter.unit_type_id"
                  label="Tipe Unit"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="2" v-if="$vuetify.breakpoint.name === 'lg'"></v-col>
              <v-col cols="12" md="4" class="d-flex">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari Laporan . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      elevation="3"
                      min-width="40"
                      height="40"
                      class="ml-2 pa-0"
                      color="teal"
                      :disabled="process.form"
                      :loading="process.form"
                      @click="prints()"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon color="white">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Print Excel</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4"/>
          <v-card-text class="py-0" style="min-height: 700px;">
            <v-skeleton-loader
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table-tbody">
              <div>
                <v-data-table
                  v-if="!process.run && pagination.total_page > 0"
                  class="table-report"
                  height="650px"
                  loading-text="Loading..."
                  loader-height="5"
                  no-results-text="Data belum ada"
                  disable-sort
                  :headers="headers"
                  :items="list"
                  :loading="process.run"
                  :items-per-page="12"
                  hide-default-footer>
                  <template v-slot:item="props">
                    <tr class="text-second" @click="transaction_id = transaction_id === '' ? props.item.transaction_id : ''">
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.transaction_user_name }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.unit_type_name }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.transaction_unit_name }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.unit_detail.building }} M<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span></td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.unit_detail.area }} M<span style="font-size: 7px; position: relative; top: -5px; margin-left: 2px;">2</span></td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.transaction_payment_type }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right">{{ parseInt(props.item.transaction_unit_price) | price }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right">{{ parseInt(props.item.transaction_additional_transaction_data.price_kpr) | price }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right">{{ parseInt(props.item.transaction_additional_transaction_data.price_fee) | price }}</td>

                      <!-- DISKON -->
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right" v-if="props.item.transaction_additional_transaction_data.discount_value > 0"
                        @click="dialog.discount = true; discount = props.item.transaction_discount_detail">
                        {{ parseInt(props.item.transaction_additional_transaction_data.discount_value) | price }}
                        <v-icon small class="mb-1" :color="style.primary">mdi-information-outline</v-icon>
                      </td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right" v-else>
                        {{ parseInt(props.item.transaction_additional_transaction_data.discount_value) | price }}
                        <v-icon small class="mb-1" color="#B2B2B2">mdi-information-outline</v-icon>
                      </td>

                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right">{{ parseInt(props.item.transaction_booking_fee) | price }}</td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right font-weight-bold">{{ parseInt(props.item.transaction_additional_transaction_data.price_fee_total) | price }}</td>

                      <!-- BIAYA LAIN-LAIN -->
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right"
                        v-for="(bll, indexbll) in props.item.transaction_additional_cost"
                        :key="indexbll">
                        {{ parseInt(bll.additional_cost_value) | price }}
                      </td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right font-weight-bold">{{ parseInt(props.item.transaction_additional_cost_total) | price }}</td>

                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right">{{ parseInt(props.item.transaction_additional_transaction_data.price_fee_customer) | price }}</td>

                      <!-- UANG MUKA -->
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right"
                        v-for="(dp, indexdp) in props.item.down_payment"
                        :key="indexdp">
                        {{ parseInt(dp.cash_tempo_value) | price }}
                      </td>
                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''" class="text-right font-weight-bold">{{ parseInt(props.item.transaction_down_payment_total) | price }}</td>

                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.transaction_status.mortage.title }}</td>

                      <td :class="transaction_id === props.item.transaction_id ? 'table-actived' : ''">{{ props.item.transaction_status.mortage.last_update | date }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-skeleton-loader>
            <div class="d-flex text-center text--secondary my-16 py-16" style="min-height: 550px;" v-if="!process.run && pagination.total_page < 1">
              <v-img 
                class="my-16 py-16"
                contain
                width="200"
                height="200"
                :src="require('../../../assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          discount: false
        },
        selected: {
          pagination: 1
        },
        transaction_id: '',
        filter: {
          title: '',
          project_id: '',
          unit_type_id: ''
        },
        items: {
          project: [],
          unit: []
        },
        headers: [],
        list: [],
        discount: [],
        total: {
          other: 0,
          dp: 0
        },
        pagination: {},
        process: {
          run: false,
          form: false
        },
        style: {
          primary: "#8BC541"
        },
        errorMessage: 'maaf anda tidak memiliki akses'
      }
    },
    components: {
      
    },
    computed: {
      
    },
    watch: {
      'filter.project_id': function(val) {
        this.fetchUnit()
        this.fetch()
      },
      'filter.unit_type_id': function(val) {
        this.fetch()
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
      this.fetchProject()
    },
    methods: {
      async fetchProject() {
        await get(`auth/company/project/list-option`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.items.project = [{
              project_id: 0,
              project_name: 'Semua'
            }]

            let p = res.data.results

            for (let i in p) {
              this.items.project.push(p[i])
            }
          }
        })
      },
      async fetchUnit() {
        await get(`auth/company/project/unit-type/list-option`, {
          params: {
            project_id: this.filter.project_id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.items.unit = [{
              unit_type_id: 0,
              unit_type_name: 'Semua'
            }]

            let p = res.data.results

            for (let i in p) {
              this.items.unit.push(p[i])
            }
          }
        })
      },
      async fetch(p) {
        this.process.run = true
        this.errorMessage = '' 

        let params = {
          page: p,
          limit: 12,
          project_id: this.filter.project_id,
          unit_type_id: this.filter.unit_type_id,
          order: 'transaction_created_datetime',
          sort: 'DESC',
          filter: [
            {
              type: 'string',
              field: 'transaction_user_name',
              value: this.filter.title,
              comparison: '<>'
            }
          ]
        }
        await get(`auth/report/project`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)

            this.total = {
              other: res.data.additional_cost_total_max,
              dp: res.data.down_payment_total_max
            }

            this.headers = [
              {
                text: 'Nama Konsumen',
                width: '200px'
              },
              {
                text: 'Unit Type',
                width: '120px'
              },
              {
                text: 'Unit / Blok',
                width: '120px'
              },
              {
                text: 'LB',
                width: '100px'
              },
              {
                text: 'LT',
                width: '100px'
              },
              {
                text: 'Booking',
                width: '100px'
              },
              {
                text: 'Harga Jual',
                width: '200px',
                align: 'end'
              },
              {
                text: 'KPR / Cash',
                width: '200px',
                align: 'end'
              },
              {
                text: 'Uang Muka',
                width: '200px',
                align: 'end'
              },
              {
                text: 'Diskon',
                width: '200px',
                align: 'end'
              },
              {
                text: 'Tanda Jadi',
                width: '200px',
                align: 'end'
              },
              {
                text: 'Total Uang Muka',
                width: '200px',
                align: 'end'
              }
            ]

            for (let i = 1; i <= this.total.other; i++) {
              this.headers.push({
                text: `BLL / Titipan ${i}`,
                width: '200px',
                align: 'end'
              })
            }

            this.headers.push(
              {
                text: 'Akumulasi BLL / Titipan',
                width: '200px',
                align: 'end'
              },
              {
                text: 'Total Bayar Konsumen',
                width: '200px',
                align: 'end'
              }
            )

            for (let i = 1; i <= this.total.dp; i++) {
              this.headers.push({
                text: `Uang Muka ${i}`,
                width: '200px',
                align: 'end'
              })
            }

            this.headers.push(
              {
                text: 'Akumulasi UM',
                width: '200px',
                align: 'end'
              },
              {
                text: 'Status Terakhir',
                width: '150px'
              },
              {
                text: 'Tanggal Status',
                width: '150px'
              }
            )
          } else if (res.status === 400 && res.error_code === "error_failed") {
            this.process.run = false
            this.$router.push({ path: '/404' }) 
          }
        })
        .catch((error) => {
          this.process.run = false
          this.errorMessage = error.response.data.msg || 'An error occurred'
        })
      },
      async prints() {
        this.process.form = true

        let params = {
          project_id: this.filter.project_id,
          unit_type_id: this.filter.unit_type_id,
          search: this.filter.title
        }

        await get(`auth/report/project/export`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            window.open(res.data.results.url, '_blank')
          }
          console.log('ini data res',res)
        })
      }
    }
  }
</script>

<style>
tr:hover {
  cursor: pointer;
  background-color: white !important;
}
.table-report table > thead > tr > th {
  position: sticky !important;
  z-index: 1;
  top: 0;
}
.table-report  table > thead > tr > th:nth-child(1) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 0; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > thead > tr > th:nth-child(2) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 200px; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > thead > tr > th:nth-child(3) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 320px; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > thead > tr > th:nth-child(7) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 400px; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(1) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 0; 
  z-index: 1;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(2) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 200px; 
  z-index: 1;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(3) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 320px; 
  z-index: 1;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(7) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 400px; 
  z-index: 1;
  background: white;
}
</style>
